//nếu đã logined thì ko thể vào router register, login...

//gõ ra, enter/tab
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
//function tiền xử lý component = ko phải component,
//vì các Hook chỉ chạy trong component, nên trong này ko thể useEffect, useState, useNavigate...
const CheckLogged = (OriginComponent) => {
  const ExtendsComponent = () => {
    //tạo Popup ở đây rất tốt
    //kiểm tra xem đã logined chưa
    const login = useSelector(({ auth }) => auth.login);
    //chuyen huong khi đã login về trang chủ
    return login.logged ? <Navigate to="/" /> : <OriginComponent />;
  };
  return ExtendsComponent;
};

export default CheckLogged;
